exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.css-zoomer {\n  float: right;\n  position: relative;\n  /*z-index: 9!important;*/\n  top: -25px;\n}\n.css-zoomer button.el-button {\n  border: none;\n  padding: 0;\n}\n.zoomer {\n  zoom: 0.80;\n}\n", ""]);

// exports
